var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87457 25.8746V3.37457H17.1246L23.3746 9.62457V25.8746H5.87457Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 4.25V25H22.5V9.25H16.875C16.5298 9.25 16.25 8.97018 16.25 8.625V4.25H6.75ZM16.4519 2.5C16.7834 2.5 17.1014 2.6317 17.3358 2.86612L23.8839 9.41421C24.1183 9.64863 24.25 9.96658 24.25 10.2981V24.625C24.25 25.7929 23.2929 26.75 22.125 26.75H7.125C5.95711 26.75 5 25.7929 5 24.625V4.625C5 3.45711 5.95711 2.5 7.125 2.5H16.4519Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1984 22.5625L12.1988 22.5625C13.1432 22.5658 14.0503 22.1923 14.7211 21.5242C15.3919 20.856 15.7717 19.9478 15.7772 18.9987V18.9983C15.777 18.2951 15.5698 17.6077 15.1817 17.0226C14.7936 16.4376 14.2418 15.9809 13.596 15.7104C12.9502 15.4398 12.2392 15.3674 11.5525 15.5023C10.8658 15.6372 10.2342 15.9733 9.73728 16.4683C9.24032 16.9633 8.90022 17.595 8.75974 18.2839C8.61926 18.9727 8.68458 19.6879 8.94768 20.3395C9.21078 20.9911 9.65983 21.5499 10.2383 21.9455C10.8167 22.3411 11.4988 22.5557 12.1984 22.5625ZM19.1727 10.7713L19.1284 10.7268L19.0841 10.7713L15.1674 14.7144L15.1236 14.7585L15.1675 14.8025L16.1991 15.8382L16.2435 15.8827L16.2877 15.8381L20.2045 11.8951L20.2483 11.851L20.2044 11.8069L19.1727 10.7713ZM13.7326 10V9.9375H13.6701H12.2194H12.1569V10V14.2197V14.2822H12.2194H13.6701H13.7326V14.2197V10ZM21.3125 17.2702V17.2077H21.25H16.96H16.8975V17.2702V18.7323V18.7948H16.96H21.25H21.3125V18.7323V17.2702Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferred);
export default __webpack_public_path__ + "static/media/referred.e0a8a23a36b49a7414cae441c17e4030.svg";
export { ForwardRef as ReactComponent };